export default "__VITE_ASSET__85e2e4df__"